// @flow

import Resource from 'speed-js-core/src/api/NestedResource';

export default class SiteEquipmentResource extends Resource {
    basePath: string = 'sites/sites/{parent}/equipment/';

    objectPath: string = 'sites/sites/{parent}/equipment/{ident}/';
}
